module.exports = __webpack_public_path__ + "img/02_2_2_2.7a41f7e3.png";